const theme = JSON.parse(localStorage.getItem("_theme"));
console.log("theme", theme);
// localStorage.setItem(
//   "_theme",
//   JSON.stringify({
//     bgImage: "bgImage",
//   })
// );

const palette = {
  // primary: "#71A0C1",
  primary: theme?.primary ? theme.primary : "#3A4041",
  secondary: theme?.secondary ? theme.secondary : "#DFDF2B",
  white: theme?.white ? theme.white : "#ffffff",
  dark: theme?.dark ? theme.dark : "#3A4041",
  gray: theme?.gray ? theme.gray : "#484848",
  red: theme?.red ? theme.red : "#F63528",
  green: theme?.green ? theme.green : "#46af4a",
  blue: theme?.blue ? theme.blue : "#1890FF",
  yellow: theme?.yellow ? theme.yellow : "#ffeb3b",

  // backgroud image
  bgImage: theme?.bgImage ? theme.bgImage : false,
  sidebar: {
    white: "#ffffff",
    dark: theme?.sidebar?.dark ? theme.sidebar.dark : "#3A4041",
  },
};

export default palette;
// #188FA7 blue
// #498467 dark green
// #DA4167 pink
// #36827F green blue
// #506854 green blue
// #D11046 dark pink red
